// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.button {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: #3d7c54;
  color: #fff;
  border: none;
  margin: 0 0 16px;
  font-size: 14px;
  letter-spacing: 1px;
  flex: 1;
  text-transform: uppercase;
  border-radius: 32px;
}
.button:hover {
  background-color: #356b48;
}
.button[disabled] {
  background-color: #dddddd;
  cursor: auto;
}
.button.\\--from-link {
  text-align: center;
}
.button.\\--sign-in {
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  background-color: transparent;
  border: none;
  color: #3d7c54;
  justify-content: center;
}
.button.\\--sign-in:hover {
  color: #1a1e22;
}
.button.\\--success {
  width: 100%;
  padding: 16px 30px;
  margin-bottom: 45px;
}
.button.\\--back {
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  background-color: transparent;
  border: none;
  color: #1a1e22;
  justify-content: center;
}
.button.\\--back:hover {
  color: #3d7c54;
}
.button.\\--skip {
  font-weight: 600;
  font-size: 14px;
  background-color: transparent;
  border: 2px solid #b2b2b2;
  color: #1a1e22;
}
.button.\\--skip:hover {
  background-color: #f2f2f2;
}
.button.\\--continue {
  max-width: 200px;
  align-self: center;
  width: 200px;
}
.button__caret {
  margin-right: 8px;
  transform: rotate(90deg);
  z-index: -1;
}
.button.\\--full-width {
  width: 100%;
}
@media (min-width: 750px) {
  .button {
    width: 33.3333333333%;
    margin-left: 8px;
    margin-right: 8px;
    padding: 16px 8px;
  }
  .button:first-of-type {
    margin-left: 0;
  }
  .button:last-of-type {
    margin-right: 0;
  }
  .button.\\--back {
    padding-left: 0;
    justify-content: left;
  }
  .button.\\--success {
    width: auto;
  }
}
.calendly-popup {
  max-height: 800px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/sage/common.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,OAAO;EACP,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,WAAW;AACb;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.button {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #3d7c54;\n  color: #fff;\n  border: none;\n  margin: 0 0 16px;\n  font-size: 14px;\n  letter-spacing: 1px;\n  flex: 1;\n  text-transform: uppercase;\n  border-radius: 32px;\n}\n.button:hover {\n  background-color: #356b48;\n}\n.button[disabled] {\n  background-color: #dddddd;\n  cursor: auto;\n}\n.button.\\--from-link {\n  text-align: center;\n}\n.button.\\--sign-in {\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  font-size: 14px;\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: #3d7c54;\n  justify-content: center;\n}\n.button.\\--sign-in:hover {\n  color: #1a1e22;\n}\n.button.\\--success {\n  width: 100%;\n  padding: 16px 30px;\n  margin-bottom: 45px;\n}\n.button.\\--back {\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  font-size: 14px;\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: #1a1e22;\n  justify-content: center;\n}\n.button.\\--back:hover {\n  color: #3d7c54;\n}\n.button.\\--skip {\n  font-weight: 600;\n  font-size: 14px;\n  background-color: transparent;\n  border: 2px solid #b2b2b2;\n  color: #1a1e22;\n}\n.button.\\--skip:hover {\n  background-color: #f2f2f2;\n}\n.button.\\--continue {\n  max-width: 200px;\n  align-self: center;\n  width: 200px;\n}\n.button__caret {\n  margin-right: 8px;\n  transform: rotate(90deg);\n  z-index: -1;\n}\n.button.\\--full-width {\n  width: 100%;\n}\n\n@media (min-width: 750px) {\n  .button {\n    width: 33.3333333333%;\n    margin-left: 8px;\n    margin-right: 8px;\n    padding: 16px 8px;\n  }\n  .button:first-of-type {\n    margin-left: 0;\n  }\n  .button:last-of-type {\n    margin-right: 0;\n  }\n  .button.\\--back {\n    padding-left: 0;\n    justify-content: left;\n  }\n  .button.\\--success {\n    width: auto;\n  }\n}\n.calendly-popup {\n  max-height: 800px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
